module.exports = __webpack_public_path__ + "static/cao-gonzalez-brais-cv-62daaef03c078920125d77429105d0b9.pdf";